/**
 * Single source of truth for securities HTTP paths.
 * - proxy: path under our Next.js API (e.g. /api-next/securities/{proxy})
 * - upstream: path when calling the external data API (relative to env url)
 */
export const securitiesRoutes = {
  earningReports: {
    internalUpstream: 'earningReports',
    proxy: 'earning-reports',
    upstream: 'v3/fundamentals/earningReports',
  },
  financials: {
    internalUpstream: 'financials',
    proxy: 'financials',
    upstream: 'v3/fundamentals/financials',
  },
  fundamentals: {
    internalUpstream: '',
    proxy: 'fundamentals',
    upstream: 'v3/fundamentals',
  },
  operationRatios: {
    internalUpstream: 'operationRatios',
    proxy: 'operation-ratios',
    upstream: 'v3/fundamentals/operationRatios',
  },
  ownership: {
    internalUpstream: 'ownership',
    proxy: 'ownership',
    upstream: 'v3/ownership/summary',
  },
  peers: { proxy: 'peers', upstream: 'v3/peers' },
  valuationRatios: {
    internalUpstream: 'valuationRatios',
    proxy: 'valuation-ratios',
    upstream: 'v3/fundamentals/valuationRatios',
  },
} as const;
